import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Label } from '../../components/ui/label';
import { SCRATCHPAD_DIRECTIONS, } from '@super/shared-types';
export const DIRECTION_LABELS = {
    read_write: 'Read + write back',
    write_only: 'Write only',
};
/**
 * Where a value lives in memory: the path, and which way it flows. A form
 * question reads memory to decide whether to ask; a signal only writes, so
 * it fixes the direction and the select is hidden. Anything a caller shows
 * only once a mapping exists comes in as children.
 */
export function ScratchpadMappingField({ label, value, available, fixedDirection, onChange, children, }) {
    return (_jsxs("div", { className: "space-y-1.5", children: [_jsx(Label, { className: "text-xs", children: label }), _jsxs("select", { value: value?.path ?? '', onChange: e => {
                    const path = e.target.value;
                    if (!path) {
                        onChange(undefined);
                        return;
                    }
                    onChange({
                        path,
                        direction: fixedDirection ?? value?.direction ?? 'read_write',
                        renderPolicy: value?.renderPolicy ?? 'auto',
                    });
                }, className: "w-full h-8 rounded-md border bg-background px-2 text-xs", children: [_jsx("option", { value: "", children: "\u2014 none \u2014" }), available.map(p => (_jsx("option", { value: p.path, children: p.label }, p.path)))] }), value && (_jsxs(_Fragment, { children: [_jsx(ScratchpadMappingHint, { path: value.path, available: available }), !fixedDirection && (_jsxs("div", { className: "pt-1.5 space-y-1.5", children: [_jsx(Label, { className: "text-xs", children: "Direction" }), _jsx("select", { value: value.direction, onChange: e => onChange({
                                    ...value,
                                    direction: e.target.value,
                                }), className: "w-full h-8 rounded-md border bg-background px-2 text-xs", children: SCRATCHPAD_DIRECTIONS.map(d => (_jsx("option", { value: d, children: DIRECTION_LABELS[d] }, d))) })] })), children] }))] }));
}
function ScratchpadMappingHint({ path, available, }) {
    const descriptor = available.find(p => p.path === path);
    if (!descriptor) {
        return (_jsxs("p", { className: "text-[10px] text-muted-foreground", children: ["Unknown path ", _jsx("code", { className: "font-mono", children: path }), " \u2014 runtime will treat as capture-only."] }));
    }
    return (_jsx("p", { className: "text-[10px] text-muted-foreground leading-relaxed", children: descriptor.description }));
}
//# sourceMappingURL=ScratchpadMappingField.js.map